function LightsMap() {
  return (
    <>
      <pointLight position={[-12, 40, 0]} intensity={0.9} />
      <ambientLight color="#a1a1a1" intensity={0.5} />
    </>
  );
}

export default LightsMap;
